import React from 'react';
import AboutContent from '../components/about/AboutContent';

const AboutPage: React.FC = () => {
  return <AboutContent />;
};

export default AboutPage;
